import React, { useCallback, useContext, useEffect, useState } from 'react';
import moment from 'moment';
import api, { cooperplaceApi } from 'services/api';
import { Fallback, Modal, Text } from 'v3/components';
import { useSnackbar } from 'v3/components/Snackbar';
import { OccurrencesAditionalFieldsContext } from 'contexts/OccurrencesAditionalFields';
import { DefaultLoadingComponent, DefaultEmptyComponent } from '../List';
import { TravelOccurrencesList } from '../TravelOccurrencesList';
import { AddNewClientOccurrence } from './AddNewOccurrence';
import { EndOccurrence } from './EndOccurrence';
import { AddDescriptionToOccurrence } from './AddDescriptionToOccurrence';
import { ChangePersonResponsible } from './ChangePersonResponsible';
import { OccurrenceInfo } from './OccurrenceInfo';
import { ActionButtons } from './ActionButtons';
import { SectionContainer } from './styles';
import {
  validateNewOccurrence,
  validateUpdateOccurrence,
  validateChangeResponsible,
  validateAnullOcorrence,
  validateOccurrenceOboticario,
  validateAttachments,
  validateAttachmentNFLinks,
  getActiveOccurrenceFields,
  isOccurrenceFieldVisible,
  attachmentRequired
} from './utils';
import { buildAttachmentFile, buildOccurrenceFormData } from 'services/apis/occurrence';
import { AnnulOcurrence } from './AnnulOcurrence';
import EndLotOccurrenceModal from './EndLotOccurrenceModal';
import { useModal } from 'hooks';
import {
  fetchReceiverTypes,
  fetchTravelOriginsAndDestinations,
  fetchTravelCte
} from 'utils/fetches'

export function OccurrencesModal({
  isOpen,
  onClose,
  travelId,
  bennerTravelId,
  fetchingTravelOccurrences,
  setFetchingTravelOccurrences,
  savingNewOccurrence,
  setSavingNewOccurrence,
  loadingUpdate,
  setLoadingUpdate,
}) {

  const endLotOccurrenceModal = useModal()

  const { selectedOccurrence, setSelectedOccurrence } = useContext(
    OccurrencesAditionalFieldsContext
  );
  const [travelOccurrences, setTravelOccurrences] = useState([]);
  const [travelAnnuledOccurrences, setTravelAnnulledOccurrences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorsOboricario, setErrorsOboticario] = useState({});
  const [occurrencesOptions, setOccurrencesOptions] = useState([]);
  const [groupOptions, setGroupsOptions] = useState([]);
  const [occurrenceType, setOccurrenceType] = useState(null);
  const [occurrenceTypeSecondary, setOccurrenceTypeSecondary] = useState(null);
  const [responsible, setResponsible] = useState([]);
  const [customerNumber, setCustomerNumber] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [description, setDescription] = useState('');
  const [occurrenceValues, setOccurrenceValues] = useState({
    payCarrier: null,
    receiverClient: null,
    retainedBranch: null,
  });
  const [files, setFiles] = useState([]);
  const [showNfErrors, setShowNfErrors] = useState(false);
  const [typeReceiverOptions, setTypeReceiverOptions] = useState([]);

  const [cteOptions, setCteOptions] = useState([]);
  const [nfOptions, setNfOptions] = useState([]);
  const [destinationOptions, setDestinationOptions] = useState([]);

  const [occurrenceOboticario, setOccurrenceOboticario] = useState({
    receiverName: '',
    typeReceiver: null,
    docReceiver: '',
    currentDelivery: null,
    cte: null,
    nfe: [],
  });

  const [show, setShow] = useState({
    addNewOccurrence: false,
    addDescriptionToOccurrence: false,
    annulOcurrence: false,
    endOccurrence: false,
    changeResponsible: false,
    endLotOccurrence: false
  });

  const [pendency, setPendency] = useState(false);
  const [displayClient, setDisplayClient] = useState(false);
  const [nextDeliveryDate, setNextDeliveryDate] = useState('');
  const [validOccurrencesConclusion, setValidOccurrencesConclusion] = useState(true);
  const [occurrenceTypeClientTypesOptions, setOccurrenceTypeClientTypesOptions] = useState([]);

  const snackbar = useSnackbar();

  function handleModalClose() {
    setOccurrenceType(null);
    setOccurrenceTypeSecondary(null);
    setResponsible([]);
    setStartDate('');
    setEndDate('');
    setPendency();
    setDisplayClient();
    setDescription('');
    setOccurrenceValues({
      payCarrier: null,
      receiverClient: null,
      retainedBranch: null,
    });
    setCustomerNumber(null);
    setNextDeliveryDate('');
    setSelectedOccurrence({});
    setShow({
      addNewOccurrence: false,
      addDescriptionToOccurrence: false,
      annulOcurrence: false,
      endOccurrence: false,
      changeResponsible: false,
      endLotOccurrence: false
    });
    setOccurrenceOboticario({
      receiverName: '',
      typeReceiver: null,
      docReceiver: '',
      currentDelivery: null,
      cte: null,
      nfe: null,
    });
    setFiles([]);
    setShowNfErrors(false);
    setErrors({});
    setErrorsOboticario({});
    onClose();
  }

  async function getOccurrencesTypesOptions() {
    try {
      setLoading(true);
      const response = await cooperplaceApi.get('occurrences/types');
      setOccurrencesOptions(response.data.message);
    } catch (error) {
      setOccurrencesOptions([]);
    } finally {
      setLoading(false);
    }
  }


  async function getOccurrencesClientTypesOptions() {
    try {
      setLoading(true);
      const response = await cooperplaceApi.get(`occurrences/client-travelId/${travelId}`);
      setOccurrenceTypeClientTypesOptions(response?.data?.occurrenceClientTypes);
    } catch (error) {
      setOccurrenceTypeClientTypesOptions([]);
    } finally {
      setLoading(false);
    }
  }


  async function getGroupOptions() {
    try {
      setLoading(true);
      const { data } = await api.get('groups', {
        params: {
          onlyActive: true,
        },
      });
      setGroupsOptions(data);
    } catch (error) {
      setGroupsOptions([]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchTravelOccurrences() {
    try {
      setFetchingTravelOccurrences(true);
      const response = await cooperplaceApi.get(`occurrences/logs/${travelId}`);
      setTravelOccurrences(response.data.message);

      const validOccurrenceConclusion = response?.data?.message.some(
        occurrence =>
          !occurrence?.userConclusion &&
          occurrence?.pendency == true &&
          ["TEMPERATURE_LOAD", "TELEMETRY"].includes(occurrence?.fullOccurrenceType?.slug)
      );

      setValidOccurrencesConclusion(!validOccurrenceConclusion);

      const annulleOcurrencesResponse = await cooperplaceApi.get(`occurrences/annul-logs/${travelId}`);
      setTravelAnnulledOccurrences(annulleOcurrencesResponse.data.message);
      setFetchingTravelOccurrences(false);
    } catch (error) {
      setFetchingTravelOccurrences(false);
      setTravelOccurrences([]);
      setTravelAnnulledOccurrences([]);
    }
  }

  useEffect(() => {
    if (!Array.isArray(occurrenceOboticario?.nfe)) return;
    const currentNfIds = new Set(occurrenceOboticario.nfe.map(nf => nf.id));
    setFiles(prev =>
      prev.map(file => ({
        ...file,
        selectedNfIds: (file.selectedNfIds || []).filter(id => currentNfIds.has(id)),
      }))
    );
  }, [occurrenceOboticario?.nfe]);

  useEffect(() => {
    if (travelId) {
      fetchTravelOccurrences();
    }

    if (isOpen) {
      getOccurrencesTypesOptions();
      getOccurrencesClientTypesOptions();
      getGroupOptions();
      fetchReceiverTypes().then(setTypeReceiverOptions);

      fetchTravelOriginsAndDestinations(travelId).then(response => {
        if (response) {
          setDestinationOptions(response?.destinations);
        } else {
          setDestinationOptions([]);
        }
      });
    }
  }, [travelId, isOpen]);

  useEffect(() => {
    try {
      if (!show?.addNewOccurrence) return;
      fetchTravelCte(travelId).then(response => {
        if (response) {
          setCteOptions(response?.ctes);
        } else {
          setCteOptions([]);
        }
      });
    } catch(err) {
      //
    }
  }, [show?.addNewOccurrence, travelId]);

  function modalTitle() {
    if (travelId && bennerTravelId) {
      return `Ocorrências da Viagem: ${travelId} - ${bennerTravelId}`;
    }
    if (travelId && !bennerTravelId) {
      return `Ocorrências da Viagem: ${travelId}`;
    }
  }

  const processPayloadCreateOccurrence = (payload, activeFields) => {

    const formData = payload?.occurrenceAttachments instanceof FormData
      ? payload?.occurrenceAttachments
      : new FormData();

    const hasConfig = activeFields?._hasConfig !== false;

    // Campos fixos sempre enviados
    if (payload?.startDate) {
      formData.append('startDate', payload?.startDate);
    }

    if (payload?.endDate) {
      formData.append('endDate', payload?.endDate);
    }

    (payload?.responsible || []).forEach(group => {
      formData.append('groupIds[]', group.id);
    });

    formData.append('pendency', String(payload?.pendency ?? false));
    formData.append('displayClient', String(payload?.displayClient ?? false));

    // Descrição
    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'description')) {
      if (payload?.description) {
        formData.append('description', payload?.description);
      }
    }

    formData.append('typeId', payload?.occurrenceType?.id);
    if (payload?.occurrenceTypeSecondary?.id) {
      formData.append('secondaryTypeId', payload?.occurrenceTypeSecondary?.id);
    }

    // Campos dinâmicos - se não há config, envia se tiver valor
    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'payCarrier')) {
      if (payload?.payCarrier) {
        formData.append('payCarrier', payload?.payCarrier);
      }
    }

    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'receiverClient')) {
      if (payload?.receiverClient) {
        formData.append('receiverClient', payload?.receiverClient);
      }
    }

    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'retainedBranch')) {
      if (payload?.retainedBranch) {
        formData.append('retainedBranch', payload?.retainedBranch);
      }
    }

    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'customerNumber')) {
      if (payload?.customerNumber) {
        formData.append('customerNumber', payload?.customerNumber);
      }
    }

    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'receiverName')) {
      if (payload?.receiverName) {
        formData.append('nameReceiver', payload?.receiverName);
      }
    }

    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'typeReceiver')) {
      if (payload?.typeReceiver?.id) {
        formData.append('typeReceiverId', payload?.typeReceiver?.id);
      }
    }

    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'docReceiver')) {
      if (payload?.docReceiver) {
        formData.append('documentReceiver', payload?.docReceiver);
      }
    }

    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'currentDelivery')) {
      if (payload?.currentDelivery?.id) {
        if (payload?.currentDelivery?.lat && payload?.currentDelivery?.lng) {
          formData.append('lng', payload?.currentDelivery?.lng);
          formData.append('lat', payload?.currentDelivery?.lat);
        }
        formData.append('deliveryId', payload?.currentDelivery?.id);
      }
    }

    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'cte')) {
      if (payload?.cte?.id) {
        formData.append('cteId', payload?.cte?.id);
      }
    }

    if (!hasConfig || isOccurrenceFieldVisible(activeFields, 'nfe')) {
      (payload?.nfe || []).forEach(nf => {
        formData.append('nfIds[]', nf?.id);
      });
    }

    if (['FIRST_DELIVERY_ATTEMPT', 'SECOND_DELIVERY_ATTEMPT'].includes(payload?.occurrenceType?.slug)) {
      if (payload?.nextDeliveryDate) {
        formData.append(
          'nextDeliveryDate',
          moment(payload.nextDeliveryDate, 'DD/MM/YYYY HH:mm').toISOString()
        );
      }
    }

    return formData;
  }

  async function processAttachments(files) {
    const attachments = new FormData();
    files.forEach((file, index) => {
      if (file?.file?.length > 1) {
        file.file.forEach((f, idx) => {
          attachments.append('file', buildAttachmentFile(f, file.description, idx));
        });
      } else {
        attachments.append('file', buildAttachmentFile(file?.file?.[0], file.description, index));
      }
    });
    return attachments;
  }

  const handleAddAttchmentsDirectly = useCallback(
    async attachments => {
      try {
        setLoadingUpdate(true);
        const newAttachments = await processAttachments(attachments);
        await cooperplaceApi.post(
          `occurrence-media/${selectedOccurrence.id}`,
          newAttachments
        );
        await fetchTravelOccurrences();
        const response = await cooperplaceApi.get(
          `occurrences/${selectedOccurrence.id}`
        );
        setSelectedOccurrence(response.data.message[0]);
      } catch (error) {
        snackbar.show(<Text>Não foi possível incluir o anexo</Text>, {
          type: 'error',
        });
        handleModalClose();
      } finally {
        setLoadingUpdate(false);
      }
    },
    [selectedOccurrence]
  );

  const handleSaveNewOccurrence = useCallback(async () => {
    try {
      setSavingNewOccurrence(true);

      const activeOccurrenceFields = getActiveOccurrenceFields(occurrenceType);

      const isDataValid = await validateNewOccurrence(
        occurrenceType,
        occurrenceTypeSecondary,
        responsible,
        startDate,
        endDate,
        description,
        setErrors,
        activeOccurrenceFields,
        nextDeliveryDate
      );

      if (attachmentRequired.includes(occurrenceType?.slug)) {
        const isAttachmentsValid = await validateAttachments({
          files,
          occurrenceTypeSlug: occurrenceType?.slug,
        });

        if (!isAttachmentsValid) {
          snackbar.show(
            <Text>Anexo obrigatório para este tipo de ocorrência</Text>,
            { type: 'error' }
          );
          setSavingNewOccurrence(false);
          return;
        }
      }

      const isValidOboticario = await validateOccurrenceOboticario(
        occurrenceType,
        {
          receiverName: occurrenceOboticario?.receiverName,
          typeReceiverId: occurrenceOboticario?.typeReceiver?.id,
          docReceiver: occurrenceOboticario?.docReceiver,
          currentDeliveryId: occurrenceOboticario?.currentDelivery?.id,
          cte: occurrenceOboticario?.cte,
          nfeIds: occurrenceOboticario?.nfe,
          files: files
        },
        setErrorsOboticario,
        activeOccurrenceFields
      );
      if (isDataValid === false || isValidOboticario === false) {
        setSavingNewOccurrence(false);
        return;
      }

      if (
        occurrenceType?.slug === 'DELIVERY' &&
        Array.isArray(occurrenceOboticario?.nfe) &&
        occurrenceOboticario.nfe.length > 0
      ) {
        const nfLinkValidation = validateAttachmentNFLinks(
          occurrenceOboticario.nfe,
          files
        );
        if (!nfLinkValidation.valid) {
          setShowNfErrors(true);
          snackbar.show(<Text>{nfLinkValidation.message}</Text>, {
            type: 'error',
          });
          setSavingNewOccurrence(false);
          return;
        }
      }

      const shouldSendAttachments = files.length > 0;
      let occurrenceAttachments;
      if (shouldSendAttachments) {
        occurrenceAttachments = occurrenceType?.slug === 'DELIVERY'
          ? buildOccurrenceFormData(files)
          : await processAttachments(files);
      }

      const createdPayload = processPayloadCreateOccurrence(
        {
          startDate: startDate
            ? moment(startDate, 'DD/MM/YYYY HH:mm:ss').toISOString()
            : null,
          endDate: endDate
            ? moment(endDate, 'DD/MM/YYYY HH:mm:ss').toISOString()
            : null,
          responsible: responsible,
          pendency,
          displayClient,
          description: description,
          occurrenceType,
          occurrenceTypeSecondary,
          occurrenceAttachments,
          customerNumber: customerNumber,
          receiverName: occurrenceOboticario?.receiverName,
          typeReceiver: occurrenceOboticario?.typeReceiver,
          docReceiver: occurrenceOboticario?.docReceiver,
          cte: occurrenceOboticario?.cte,
          nfe: occurrenceOboticario?.nfe,
          currentDelivery: occurrenceOboticario?.currentDelivery,
          payCarrier: occurrenceValues?.payCarrier,
          receiverClient: occurrenceValues?.receiverClient,
          retainedBranch: occurrenceValues?.retainedBranch,
          nextDeliveryDate,
        },
        activeOccurrenceFields
      )

      await cooperplaceApi.post(`occurrences/${travelId}`, createdPayload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      await fetchTravelCte(travelId).then(response => {
        if (response) {
          setCteOptions(response?.ctes);
        } else {
          setCteOptions([]);
        }
      });
      await fetchTravelOccurrences();
      await getOccurrencesClientTypesOptions();

      setOccurrenceType([]);
      setOccurrenceTypeSecondary(null);
      setResponsible([]);
      setStartDate('');
      setEndDate('');
      setPendency();
      setDisplayClient();
      setCustomerNumber(null)
      setDescription('');
      setOccurrenceValues({
        payCarrier: null,
        receiverClient: null,
        retainedBranch: null,
      });
      setFiles([]);
      setShowNfErrors(false);
      setNextDeliveryDate('');
      setShow(old => ({ ...old, addNewOccurrence: false }));
      setSavingNewOccurrence(false);
      setOccurrenceOboticario({
        receiverName: '',
        typeReceiver: null,
        docReceiver: '',
        currentDelivery: null,
        cte: null,
        nfe: [],
      })
    } catch (error) {
      const message = error?.response?.data?.error || error?.response?.data?.message;
      setSavingNewOccurrence(false);
      snackbar.show(
        <Text>{message || 'Não foi possível salvar a ocorrência'}</Text>,
        { type: 'error' }
      );
    }
  }, [
    responsible,
    startDate,
    endDate,
    pendency,
    displayClient,
    occurrenceType,
    description,
    occurrenceValues,
    customerNumber,
    occurrenceOboticario,
    occurrenceTypeSecondary,
    errorsOboricario,
    errors,
    files,
    showNfErrors,
    nextDeliveryDate,
  ]);

  const handleAddEndOccurrenceInfo = useCallback(async () => {
    try {
      setLoadingUpdate(true);
      const occurrenceTypeSlug = selectedOccurrence?.fullOccurrenceType?.slug;
      const isDataValid = await validateUpdateOccurrence({
        description,
        startDate,
        endDate,
        setErrors,
        nextDeliveryDate,
        occurrenceTypeSlug,
      });
      if (isDataValid === false) {
        setLoadingUpdate(false);
        return false;
      }
      const shouldSendAttachments = files.length > 0;
      let occurrenceAttachments;
      if (shouldSendAttachments) {
        occurrenceAttachments = await processAttachments(files);
      }
      await cooperplaceApi.put(`occurrences/${selectedOccurrence.id}`, {
        startDate: moment(startDate, 'DD/MM/YYYY HH:mm:ss').toISOString(),
        endDate: endDate
          ? moment(endDate, 'DD/MM/YYYY HH:mm:ss').toISOString()
          : null,
        description,
        logType: 'concluir',
        payCarrier: occurrenceValues?.payCarrier,
        receiverClient: occurrenceValues?.receiverClient,
        retainedBranch: occurrenceValues?.retainedBranch,
        nextDeliveryDate: nextDeliveryDate ? moment(nextDeliveryDate, 'DD/MM/YYYY HH:mm').toISOString() : undefined
      });
      if (shouldSendAttachments) {
        await cooperplaceApi.post(
          `occurrence-media/${selectedOccurrence.id}`,
          occurrenceAttachments
        );
      }
      setStartDate('');
      setEndDate('');
      setDescription('');
      setOccurrenceValues({
        payCarrier: null,
        receiverClient: null,
        retainedBranch: null,
      });
      setCustomerNumber(null);
      setNextDeliveryDate('');
      setFiles([]);
      setShow(old => ({ ...old, endOccurrence: false }));
      await fetchTravelOccurrences();
      const response = await cooperplaceApi.get(
        `occurrences/${selectedOccurrence.id}`
      );
      setSelectedOccurrence(response.data.message[0]);
      setLoadingUpdate(false);
    } catch (error) {
      const message = error?.response?.data?.message;
      setStartDate('');
      setEndDate('');
      setDescription('');
      setOccurrenceValues({
        payCarrier: null,
        receiverClient: null,
        retainedBranch: null,
      });
      setFiles([]);
      setCustomerNumber(null);
      setNextDeliveryDate('');
      setLoadingUpdate(false);
      snackbar.show(
        <Text>{message || 'Não foi possível concluir a ocorrência'}</Text>,
        {
          type: 'error',
        }
      );
    }
  }, [
    description,
    startDate,
    endDate,
    occurrenceValues,
    selectedOccurrence,
    files,
    nextDeliveryDate,
  ]);

  const handleChangeResponsibleData = useCallback(async () => {
    try {
      setLoadingUpdate(true);
      const isDataValid = await validateChangeResponsible({
        description,
        responsible,
        setErrors,
      });
      if (isDataValid === false) {
        setLoadingUpdate(false);
        return false;
      }
      await cooperplaceApi.put(`occurrences/${selectedOccurrence.id}`, {
        groupIds: responsible.map(group => group.id),
        description,
        logType: 'alterar',
      });
      const response = await cooperplaceApi.get(
        `occurrences/${selectedOccurrence.id}`
      );
      setSelectedOccurrence(response.data.message[0]);
      setResponsible([]);
      setDescription('');
      setShow(old => ({ ...old, changeResponsible: false }));
      await fetchTravelOccurrences();
      setLoadingUpdate(false);
    } catch (error) {
      setResponsible([]);
      setDescription('');
      setShow(old => ({ ...old, changeResponsible: false }));
      setLoadingUpdate(false);
      snackbar.show(<Text>Não foi possível alterar o responsável</Text>, {
        type: 'error',
      });
    }
  }, [description, responsible, selectedOccurrence]);

  const handleAddNewDescription = useCallback(async () => {
    try {
      setLoadingUpdate(true);
      const isDataValid = await validateUpdateOccurrence({
        description,
        startDate,
        endDate,
        setErrors,
      });
      if (isDataValid === false) {
        setLoadingUpdate(false);
        return false;
      }
      const shouldSendAttachments = files.length > 0;
      let occurrenceAttachments;
      if (shouldSendAttachments) {
        occurrenceAttachments = await processAttachments(files);
      }
      await cooperplaceApi.put(`occurrences/${selectedOccurrence.id}`, {
        startDate: moment(startDate, 'DD/MM/YYYY HH:mm:ss').toISOString(),
        endDate: endDate
          ? moment(endDate, 'DD/MM/YYYY HH:mm:ss').toISOString()
          : null,
        description,
        payCarrier: occurrenceValues?.payCarrier,
        receiverClient: occurrenceValues?.receiverClient,
        retainedBranch: occurrenceValues?.retainedBranch,
        logType: 'alterar',
      });
      if (shouldSendAttachments) {
        await cooperplaceApi.post(
          `occurrence-media/${selectedOccurrence.id}`,
          occurrenceAttachments
        );
      }
      const response = await cooperplaceApi.get(
        `occurrences/${selectedOccurrence.id}`
      );
      setSelectedOccurrence(response.data.message[0]);
      setStartDate('');
      setEndDate('');
      setDescription('');
      setOccurrenceValues({
        payCarrier: null,
        receiverClient: null,
        retainedBranch: null,
      });
      setFiles([]);
      setCustomerNumber(null);
      setShow(old => ({ ...old, addDescriptionToOccurrence: false }));
      await fetchTravelOccurrences();
      setLoadingUpdate(false);
    } catch (error) {
      const message = error?.response?.data?.message;
      setStartDate('');
      setEndDate('');
      setDescription('');
      setOccurrenceValues({
        payCarrier: null,
        receiverClient: null,
        retainedBranch: null,
      });
      setCustomerNumber(null);
      setFiles([]);
      setShow(old => ({ ...old, addDescriptionToOccurrence: false }));
      setLoadingUpdate(false);
      snackbar.show(
        <Text>{message || 'Não foi possível adicionar descrição'}</Text>,
        {
          type: 'error',
        }
      );
      handleModalClose();
    }
  }, [
    description,
    startDate,
    endDate,
    occurrenceValues,
    selectedOccurrence,
    files,
  ]);


  const handleAnnulOcurrence = useCallback(async () => {
    try {
      setLoadingUpdate(true);
      const isDataValid = await validateAnullOcorrence({
        description,
        setErrors,
      });
      if (isDataValid === false) {
        setLoadingUpdate(false);
        return false;
      }
      await cooperplaceApi.put(`occurrences/annul/${selectedOccurrence.id}`, {
        description,
        logType: 'alterar',
      });
      const response = await cooperplaceApi.get(
        `occurrences/${selectedOccurrence.id}`
      );
      setSelectedOccurrence(response.data.message[0]);
      setDescription('');
      setShow(old => ({ ...old, annulOcurrence: false }));
      await fetchTravelOccurrences();
      setLoadingUpdate(false);
      return null
    } catch (error) {
      const message = error?.response?.data?.message;
      setDescription('');
      setShow(old => ({ ...old, annulOcurrence: false }));
      setLoadingUpdate(false);
      snackbar.show(
        <Text>{message || 'Não foi possível anular a ocorrência'}</Text>,
        {
          type: 'error',
        }
      );
      handleModalClose();
      return null
    }
  }, [
    description,
    selectedOccurrence,
  ]);

  function occurrenceDetails() {
    return (
      <>
        {selectedOccurrence?.id && (
          <>
            <OccurrenceInfo
              selectedOccurrence={selectedOccurrence}
              show={show}
              startDate={startDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              endDate={endDate}
              errors={errors}
              loadingUpdate={loadingUpdate}
              savingNewOccurrence={savingNewOccurrence}
              setOccurrenceValues={setOccurrenceValues}
              occurrenceValues={occurrenceValues}
              setCustomerNumber={setCustomerNumber}
              handleAddAttchmentsDirectly={
                handleAddAttchmentsDirectly
              }
            />
          </>
        )}
        {show.endOccurrence ? (
          <EndOccurrence
            description={description}
            setDescription={setDescription}
            setShow={setShow}
            errors={errors}
            setErrors={setErrors}
            handleAddEndOccurrenceInfo={handleAddEndOccurrenceInfo}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            loadingUpdate={loadingUpdate}
            files={files}
            setFiles={setFiles}
            nextDeliveryDate={nextDeliveryDate}
            setNextDeliveryDate={setNextDeliveryDate}
            occurrenceTypeSlug={selectedOccurrence?.fullOccurrenceType?.slug}
            selectedOccurrence={selectedOccurrence}
          />
        ) : show.addDescriptionToOccurrence ? (
          <AddDescriptionToOccurrence
            description={description}
            setDescription={setDescription}
            setShow={setShow}
            errors={errors}
            setErrors={setErrors}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            handleAddNewDescription={handleAddNewDescription}
            loadingUpdate={loadingUpdate}
            files={files}
            setFiles={setFiles}
          />
        ) : show.changeResponsible ? (
          <ChangePersonResponsible
            responsible={responsible}
            setResponsible={setResponsible}
            description={description}
            setDescription={setDescription}
            setShow={setShow}
            errors={errors}
            setErrors={setErrors}
            handleChangeResponsibleData={handleChangeResponsibleData}
            loadingUpdate={loadingUpdate}
            groupOptions={groupOptions}
          />
        ) : show.annulOcurrence ? (
          <AnnulOcurrence
            description={description}
            setDescription={setDescription}
            setShow={setShow}
            errors={errors}
            setErrors={setErrors}
            handleaAnnulOcorrence={handleAnnulOcurrence}
            loadingUpdate={loadingUpdate}
          />
        ) : null}
      </>
    )
  }

  return (
    <Modal
      show={isOpen}
      handleClose={handleModalClose}
      heading={
        <Text type="regular" color="dark" weight="500">
          {modalTitle()}
        </Text>
      }
      body={
        <>
          {show.addNewOccurrence ? (
            <AddNewClientOccurrence
              endDate={endDate}
              startDate={startDate}
              occurrenceType={occurrenceType}
              setOccurrenceType={setOccurrenceType}
              occurrenceTypeSecondary={occurrenceTypeSecondary}
              setOccurrenceTypeSecondary={setOccurrenceTypeSecondary}
              occurrencesOptions={
                occurrenceTypeClientTypesOptions?.length > 0
                  ? occurrenceTypeClientTypesOptions
                  : occurrencesOptions
              }
              isClientOccurrence={occurrenceTypeClientTypesOptions?.length > 0}
              responsible={responsible}
              setResponsible={setResponsible}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              description={description}
              setDescription={setDescription}
              occurrenceValues={occurrenceValues}
              setOccurrenceValues={setOccurrenceValues}
              setShow={setShow}
              customerNumber={customerNumber}
              setCustomerNumber={setCustomerNumber}
              handleSaveNewOccurrence={handleSaveNewOccurrence}
              savingNewOccurrence={savingNewOccurrence}
              pendency={pendency}
              setPendency={setPendency}
              displayClient={displayClient}
              setDisplayClient={setDisplayClient}
              errors={errors}
              setErrors={setErrors}
              addButton
              files={files}
              setFiles={setFiles}
              groupOptions={groupOptions}
              typeReceiverOptions={typeReceiverOptions}
              setOccurrenceOboticario={setOccurrenceOboticario}
              occurrenceOboticario={occurrenceOboticario}
              nfOptions={nfOptions}
              setNfOptions={setNfOptions}
              cteOptions={cteOptions}
              destinationOptions={destinationOptions}
              errorsOboticario={errorsOboricario}
              setErrorsOboticario={setErrorsOboticario}
              showNfErrors={showNfErrors}
              nextDeliveryDate={nextDeliveryDate}
              setNextDeliveryDate={setNextDeliveryDate}
            />
          ) : (
            <>
              {!show.addNewOccurrence &&
                !show.addDescriptionToOccurrence &&
                !show.endOccurrence &&
                !show.annulOcurrence &&
                !show.endLotOccurrence &&
                !show.changeResponsible ? (
                <ActionButtons
                  show={show}
                  setShow={setShow}
                  selectedOccurrence={selectedOccurrence}
                  setSelectedOccurrence={setSelectedOccurrence}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  loading={loading}
                  setOccurrenceValues={setOccurrenceValues}
                  endLotOccurrenceModal={endLotOccurrenceModal}
                  validOccurrencesConclusion={validOccurrencesConclusion}
                />
              ) : null}
              <Fallback
                fall={
                  fetchingTravelOccurrences || (travelOccurrences.length === 0 && travelAnnuledOccurrences.length === 0)
                }
                component={
                  fetchingTravelOccurrences ? (
                    <DefaultLoadingComponent />
                  ) : !fetchingTravelOccurrences &&
                    (travelOccurrences.length === 0 && travelAnnuledOccurrences.length === 0) ? (
                    <DefaultEmptyComponent />
                  ) : null
                }
              >
                <SectionContainer>
                  {travelOccurrences.length > 0 && <TravelOccurrencesList
                    selectedOccurrence={selectedOccurrence}
                    setSelectedOccurrence={setSelectedOccurrence}
                    occurrences={travelOccurrences}
                    show={show}
                  />}
                  {!selectedOccurrence?.annulled && occurrenceDetails()}
                  {travelAnnuledOccurrences.length > 0 && <TravelOccurrencesList
                    selectedOccurrence={selectedOccurrence}
                    setSelectedOccurrence={setSelectedOccurrence}
                    occurrences={travelAnnuledOccurrences}
                    show={show}
                    annulledList
                  />}
                  {selectedOccurrence?.annulled && occurrenceDetails()}
                </SectionContainer>
              </Fallback>
              <EndLotOccurrenceModal
                isOpen={endLotOccurrenceModal.isOpen}
                isClosed={endLotOccurrenceModal.close}
                occurrencesOptions={occurrencesOptions}
                travelId={travelId}
                fetchTravelOccurrences={fetchTravelOccurrences}
              />
            </>
          )}
        </>
      }
    />
  );
}
